/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generate_Magic_LinkInputs */

const en_generate_magic_link = /** @type {(inputs: Generate_Magic_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Magic Link`)
};

const es_generate_magic_link = /** @type {(inputs: Generate_Magic_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar link magico`)
};

/**
* | output |
* | --- |
* | "Generate Magic Link" |
*
* @param {Generate_Magic_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const generate_magic_link = /** @type {((inputs?: Generate_Magic_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generate_Magic_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_generate_magic_link(inputs)
	return es_generate_magic_link(inputs)
});